// extracted by mini-css-extract-plugin
export default {"container":"Scrollable_container__6eSML"};